export function isEmptyObject(obj) {
  return (
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
}

export function isEmptyFileValue(fileValue) {
  const fileValueWithoutExpiredAt = { ...fileValue };
  delete fileValueWithoutExpiredAt.expiredAt;
  return isEmptyObject(fileValueWithoutExpiredAt);
}
